// Ids are only unique within a region's database, so cross-region lookups key
// by region alongside the id.
export function regionKey(region: string, id: number): string {
  return `${region}:${id}`;
}
